import NotificationPanel from './notification-panel.vue'

export default NotificationPanel
